
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-chatbot",
      function () {
        return require("private-next-pages/whatsapp-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-chatbot"])
      });
    }
  